import { render, staticRenderFns } from "./Required.vue?vue&type=template&id=19af6a2d&scoped=true&"
import script from "./Required.vue?vue&type=script&lang=js&"
export * from "./Required.vue?vue&type=script&lang=js&"
import style0 from "./Required.vue?vue&type=style&index=0&id=19af6a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af6a2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19af6a2d')) {
      api.createRecord('19af6a2d', component.options)
    } else {
      api.reload('19af6a2d', component.options)
    }
    module.hot.accept("./Required.vue?vue&type=template&id=19af6a2d&scoped=true&", function () {
      api.rerender('19af6a2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Forms/Fields/Required.vue"
export default component.exports